
import { Component, Prop, Vue } from 'vue-property-decorator';
import MemberForm from '@/views/member/MemberForm.vue';
import UserForm from '@/views/member/UserForm.vue';
import moment from 'moment';
import { Route } from 'vue-router';
import api from '@/api';
import Swal from 'sweetalert2';

const { member } = api;

@Component({
  components: {
    MemberForm,
    UserForm,
  },
})
export default class UserEdit extends Vue {
  @Prop() private userId!: string;

  private loading = false;

  private user = {
    userId: null,
    userIdPublic: null,
    email: null,
    taxId: null,
    firstName: null,
    lastName: null,
    gender: null,
    countryCode: null,
    mobile: null,
    pid: null,
    authFailReason: null,
    authStatus: null,
    birthday: null,
    city: null,
    area: null,
    address: null,
    currentCity: null,
    currentArea: null,
    currentAddress: null,
    createdOn: null,
    dataAudiFlow: null,
    inviter: null,
    inviterPId: null,
    isEnable: null,
    isInBlackList: null,
    registerPlatform: null,
    roles: [],
    zipcode: null,
    profilePic: null,
    identityIdPic: null,
    identityIdPic2: null,
    taxCertificationPic: null,
    electronicSignature: null,
  };

  private change(evt: any) {
    (this.user as any)[evt.key] = evt.value;
  }

  private async submit(valid: boolean) {
    if (valid) {
      this.loading = true;
      const parameters = {
        ...this.user,
        birthday: new Date(`${this.user.birthday}T00:00:00`),
      };
      const { status } = await member.edit(this.userId, parameters);
      if (status === 1) {
        await Swal.fire({
          icon: 'info',
          title: '操作完成',
        });
      }
      this.loading = false;
    }
  }

  private async requestData() {
    const { data } = await member.get(this.userId);
    if (data.birthday) {
      data.birthday = moment(data.birthday).format('YYYY-MM-DD');
    }
    this.user = data;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: (vm: UserEdit) => void) => void,
  ) {
    await next(async (vm) => {
      await vm.requestData();
    });
  }
}
